import React from "react"
import serb2bLogo from "../images/serb2b-logo.svg"

const Serb2bPromo = () => {
  return (
    <div className="serb2b-promo">
      <div className="serb2b-promo-inner">
        <div className="serb2b-promo-content">
          <div className="serb2b-promo-badge">Yeni Ürün</div>
          <h3 className="serb2b-promo-title">
            Üretici ve Toptancı için<br /><span>B2B E-Ticaret Altyapısı</span>
          </h3>
          <p className="serb2b-promo-desc">
            serB2B ile toptan satış süreçlerinizi dijitalleştirin. Bayi yönetimi, özel fiyatlandırma,
            entegrasyon desteği ve mobil uyumlu altyapı ile işinizi büyütün.
          </p>
          <div className="serb2b-promo-features">
            <div className="serb2b-promo-feature">
              <div className="serb2b-promo-feature-icon">&#9881;</div>
              <span>Modüler Yapı</span>
            </div>
            <div className="serb2b-promo-feature">
              <div className="serb2b-promo-feature-icon">&#9741;</div>
              <span>Bayi Yönetimi</span>
            </div>
            <div className="serb2b-promo-feature">
              <div className="serb2b-promo-feature-icon">&#9889;</div>
              <span>Entegrasyonlar</span>
            </div>
            <div className="serb2b-promo-feature">
              <div className="serb2b-promo-feature-icon">&#9743;</div>
              <span>Mobil Uyumlu</span>
            </div>
          </div>
          <a
            href="https://www.serb2b.com"
            target="_blank"
            rel="noopener noreferrer"
            className="serb2b-promo-cta"
            title="serB2B - Üretici ve Toptancı için B2B E-Ticaret Altyapısı"
          >
            serB2B'yi Keşfedin <span className="serb2b-promo-cta-arrow">&rarr;</span>
          </a>
        </div>
        <div className="serb2b-promo-visual">
          <div className="serb2b-promo-logo-box">
            <img src={serb2bLogo} alt="serB2B - B2B E-Ticaret Altyapısı" className="serb2b-promo-logo-img" />
          </div>
        </div>
      </div>
    </div>
  )
}

export default Serb2bPromo
